import _ from 'lodash';

function LineCreateController($scope, $filter, $state, $stateParams, $window, AppConstants, PageHeading, CityComponent, LineComponent, Toast, Line) {
	'ngInject';

	const vm = this;

	vm.sideBar = false;
	// option - for view with buttons,
	vm.partialTemplate = 'options';
	vm.showAddStation = false;
	vm.selectItemFromAutoComplete = selectItemFromAutoComplete;
	vm.selectPositionAfter = selectPositionAfter;
	vm.selectStation = selectStation;
	vm.changePartialTemplate = changePartialTemplate;
	vm.searchCities = CityComponent.searchCities;
	vm.getResultSearchCities = CityComponent.getResultSearchCities;
	vm.createLine = createLine;
	vm.clickHandler = clickHandler;
	vm.addStation = addStation;
	vm.addNewStationOnLine = addNewStationOnLine;
	vm.cancelAddStation = cancelAddStation;
	vm.clear = clear;
	vm.sendForm = sendForm;
	vm.editPoint = false;
	vm.createEditLine = createEditLine;
	let indexOfEditPoint = null;
	vm.deleteStation = deleteStation;
	vm.line = {
		'has_reverse_line': 0,
		'stations': [],
		'valid_to': Line.valid_to || '',
		'valid_from': Line.valid_from || '',
		'translations': []
	};
	vm.points = [];
	vm.point = {
		'city': {
			'stations': []
		},
		'position': 'last',
		'positionAfter': {},
		'typeAction': 'create'
	};
	vm.getPaginationInfo = LineComponent.getPaginationInfo();
	vm.yesterdayDate = new Date();
	vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
	vm.languages = AppConstants.languages;

	// Edit line components
	vm.isEditLine = false;
	vm.updateLine = updateLine;
	vm.areLineStationsChanged = false;

	vm.clearResults = clearResults;

	activate();

	function activate() {
		let heading;
		let title;
		if ($stateParams.lineId) {
			heading = $filter('translate')('HEADING.EDITING_LINE');
			title = `BTMS | ${$filter('translate')('HEADING.EDITING_LINE')}`;
			editLine();
		} else {
			heading = $filter('translate')('HEADING.CREATING_NEW_LINE');
			title = `BTMS | ${$filter('translate')('TITLE.NEW_LINE')}`;
		}

		PageHeading.setPageHeading(heading, title);

		if (!$stateParams.lineId) {
			vm.line.translations_reverse = [];
		}

		let translation;
		vm.languages.forEach((language) => {
			translation = _.find(Line.translations, {'lang': language});

			vm.line.translations.push({
				'lang': language,
				'name': translation ? translation.name : ''
			});

			if (!$stateParams.lineId) {
				vm.line.translations_reverse.push({
					'lang': language
				});
			}
		});
	}

	/** */
	function editLine() {
		vm.isEditLine = true;
		vm.points = [];
		vm.line.has_reverse_line = Line.has_reverse_line;

		// Sort stations by position
		Line.stations.sort(function (a, b) {
			return a.pivot.position - b.pivot.position;
		});

		Line.stations.forEach((station) => {
			vm.points.push({
				'city': {
					'id': station.city.id,
					'translation': station.city.translation
				},
				'station': {
					'id': station.id,
					'name': station.translation.name
				},
				'name': station.city.translation.name,
				'color': AppConstants.colors.darkBlue
			});
		});
	}

	function createEditLine(params, isEditing) {
		let isUserWarned = isEditing;

		if (vm.points.length <= 1) {
			Toast.error($filter('translate')('ERRORS.REQUIRED_STATIONS'));

			return false;
		}
		if (isUserWarned) {
			if (!$window.confirm($filter('translate')('CONFIRM.CHANGE_STATIONS_LINE'))) {
				return false;
			}
		} else {
			isUserWarned = true;
		}

		for (let i = 0; i < vm.points.length; i++) {
			if (!isUserWarned) {
				const idsDoesNotMatch = Line.stations[i].pivot.station_id !== vm.points[i].station.id;
				const positionsDoesNotMatch = Line.stations[i].pivot.position !== i + 1;
				if ((idsDoesNotMatch || positionsDoesNotMatch) && !isUserWarned ) {
					return false;
				} else {
					isUserWarned = true;
				}
			}

			params.stations.push({
				'position': i + 1,
				'station_id': vm.points[i].station.id,
				'city_id': vm.points[i].city.id
			});
		}

		let nameLengthInvalid = false;
		const form = $scope.createEditLine;

		for (let i = 0; i < vm.languages.length; i++) {
			if (form['name-' + i].$error.minlength || form['name-' + i].$error.maxlength) {
				nameLengthInvalid = true;
				break;
			}

			if (params.has_reverse_line && (form['nameReverse-' + i].$error.minlength || form['nameReverse-' + i].$error.maxlength)) {
				nameLengthInvalid = true;
				break;
			}
		}

		if (form.$error.required || nameLengthInvalid) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		if (isEditing) {
			updateLine(params);
		} else {
			createLine(params);
		}
	}

	/**
	 * Update line
	 *
	 * @param {Object} params ()
	 */
	function updateLine(params) {
		LineComponent.updateLine($stateParams.lineId, params)
			.then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.UPDATE_LINE'));
					$state.go('app.private.lines.list');
				}
			});
	}

	/**
	 *  Create new line
	 */
	function createLine(params) {
		LineComponent.createLine(params)
			.then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.CREATE_LINE'));
					$state.go('app.private.lines.list');
				}
			});
	}

	/**
	 * Clears the results from the autocomplete search.
	 */
	function clearResults() {
		CityComponent.clearResultSearchCities();
		// remove values for station
		vm.point.stationId = null;
		vm.point.stationName = null;
	}

	/**
	 *  After added new station, cleared query(this isa value of city field), stations(in drop-down field)
	 *  and set false of showAddStation - hide form for add station
	 */
	function clear() {
		vm.query = '';
		vm.showAddStation = false;
	}

	function clickHandler(event, point, index) {
		$scope.$apply(function () {
			CityComponent.fetchCity(point.city.id).then(function (res) {
				vm.point.city.stations = res.stations;
			});
			vm.editPoint = true;
			selectItemFromAutoComplete(point.city);
			vm.point.position = 'default';
			vm.point.typeAction = 'edit';
			vm.point.stationId = point.station.id;
			vm.point.stationName = point.station.name;
			// set default color of last selected point
			if (indexOfEditPoint !== null) {
				vm.points[indexOfEditPoint].active = false;
			}
			indexOfEditPoint = index;
			vm.partialTemplate = 'addStation';
			vm.points[indexOfEditPoint].active = true;
			vm.redraw();
		});
	}

	/**
	 * When we adding new point to line, we can make a choice that point to be after a other one from line and
	 * we must be select one existed point (After point).
	 *
	 */
	function selectPositionAfter(point) {
		vm.point.positionAfter.id = point.city.id;
		vm.point.positionAfter.name = point.city.translation.name;
		vm.point.positionAfter.stationId = point.station.id;
	}

	function selectItemFromAutoComplete(city) {
		vm.point.city = city;
		vm.query = city.translation.name;
	}

	function selectStation(station) {
		vm.point.stationId = station.id;
		vm.point.stationName = station.translation.name;
	}

	/**
	 * When form was submitted, here we check what action must be done.(update or create)
	 */
	function sendForm(currentPoint, form) {
		let sameStationError = false;

		for (let i = 0; i < vm.points.length; i++) {
			if (currentPoint.stationId === vm.points[i].station.id) {
				sameStationError = true;
				break;
			}
		}

		if (sameStationError && !vm.editPoint) {
			Toast.error($filter('translate')('ERRORS.SAME_STATION'));

			return false;
		}

		if (form.$error.required) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		if (vm.editPoint) {
			updateStation(currentPoint);
		} else {
			addStation(currentPoint);
		}

		cancelAddStation(form);
	}

	/**
	 * Adding point(station) on line
	 */
	function addStation(point) {
		vm.point = {'position': 'last', 'positionAfter': {}};
		addNewStationOnLine(point);
		vm.redraw();
		clear();
	}

	/**
	 * Update point(station) on line
	 */
	function updateStation(point) {
		vm.existStation = true;

		for (let i = 0; i < vm.points.length; i++) {
			if (point.stationId === vm.points[i].station.id) {
				vm.existStation = false;
				return vm.existStation;
			}
		}

		if (point.position === 'default' && vm.existStation ) {
			vm.points[indexOfEditPoint].station.id = point.stationId;
			vm.points[indexOfEditPoint].station.name = point.stationName;
			vm.points[indexOfEditPoint].city.translation.name = point.city.translation.name;
			vm.points[indexOfEditPoint].city.id = point.city.id;
			vm.points[indexOfEditPoint].name = point.city.translation.name;
			vm.points[indexOfEditPoint].color = AppConstants.colors.darkBlue;
		} else {
			vm.points.splice(indexOfEditPoint, 1);
			addNewStationOnLine(point);
		}

		vm.redraw();
	}

	function addNewStationOnLine(point) {
		const newPoint = {
			'city': {
				'id': point.city.id,
				'translation': point.city.translation
			},
			'station': {
				'id': point.stationId,
				'name': point.stationName
			},
			'name': point.city.translation.name,
			'color': AppConstants.colors.darkBlue
		};
		if (point.position === 'first') {
			vm.points.splice(0, 0, newPoint);
		} else if (point.position === 'after') {
			for (let i = 0; i < vm.points.length; i++) {
				if (vm.points[i].station.id === point.positionAfter.stationId) {
					vm.points.splice(i + 1, 0, newPoint);
					break;
				}
			}
		} else {
			vm.points.push(newPoint);
		}
	}

	function deleteStation() {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			vm.points.splice(indexOfEditPoint, 1);
			vm.redraw();
			vm.editPoint = false;
			vm.point = {'position': 'last', 'positionAfter': {}};
			vm.query = '';
			vm.partialTemplate = 'options';
			indexOfEditPoint = null;
		}
	}

	/**
	 * Change form for add/edit point(station)
	 *
	 * @param partial
	 */
	function changePartialTemplate(partial) {
		vm.point = {'position': 'last', 'positionAfter': {}, 'typeAction': 'create'};
		vm.partialTemplate = partial;
	}

	function cancelAddStation(form) {
		vm.editPoint = false;
		form.$setPristine();
		if (indexOfEditPoint !== null) {
			vm.points[indexOfEditPoint].color = AppConstants.colors.darkBlue;
			vm.redraw();
		}
		vm.point = {'position': 'last', 'positionAfter': {}, 'typeAction': 'create'};
		vm.query = '';
		vm.partialTemplate = 'options';
	}
}

export default LineCreateController;



/** WEBPACK FOOTER **
 ** ./client/private/lines/create/create.controller.js
 **/